import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";

export const Notifications = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full p-6">
            <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold text-gray-900">Notifications</h3>
                <button onClick={() => navigate("/")} className="h-10 w-10">
                    <FontAwesomeIcon icon={faXmark}/>
                </button>
            </div>
        </div>
    );
};
